// Produits "Coming soon" dans les filtres de collection.
// Dès qu'un filtre est actif, la grille est demandée avec filter.v.availability=1 (produits en stock) :
// les Coming soon sans stock en disparaissent. On demande en parallèle la section mm-collection-coming-soon
// avec les mêmes filtres sans le stock : elle renvoie ces produits, chacun avec l'id du produit de la grille
// qui le précède (data-mm-cs-after, vide = en tête), et on les insère à leur place.
// Si ce produit n'est pas encore affiché ("Charger plus"), la carte attend : mmComingSoonPlace() est
// rappelée après chaque page chargée.

let mmComingSoonToken = 0;

async function mmComingSoonFetch(url_filters) {
	const token = ++mmComingSoonToken;
	const params = new URLSearchParams(url_filters);
	if (!params.has("filter.v.availability")) return { token, results: null };

	params.delete("filter.v.availability");
	params.delete("page");
	params.delete("sections");
	params.set("section_id", "mm-collection-coming-soon");
	try {
		const response = await fetch("//" + location.host + location.pathname + "?" + params.toString());
		if (!response.ok) return { token, results: null };
		const doc = new DOMParser().parseFromString(await response.text(), "text/html");
		return { token, results: doc.querySelector(".mm-cs-results") };
	} catch (err) {
		console.error("Erreur lors du chargement des produits Coming soon:", err);
		return { token, results: null };
	}
}

// submit = true : la grille vient d'être remplacée, on y insère les Coming soon.
// submit = false (tiroir mobile) : seul le bouton "Voir les X produits" est mis à jour.
function mmComingSoonApply(sectionEl, comingSoon, productsCount, submit) {
	// Une requête plus récente est en cours
	if (comingSoon.token !== mmComingSoonToken) return;

	const results = comingSoon.results;
	const grid = sectionEl.querySelector(".mm-collection-grid");
	if (submit && grid) {
		grid.mmComingSoonPending = [];
		if (results) {
			results.querySelectorAll("[data-mm-cs-after]").forEach((item) => {
				const card = item.querySelector(".mm-product-card");
				if (!card) return;
				card.dataset.mmCsAfter = item.dataset.mmCsAfter;
				grid.mmComingSoonPending.push(card);
			});
		}
		mmComingSoonPlace(grid);
	}

	const comingSoonCount = results ? parseInt(results.dataset.mmCsCount, 10) || 0 : 0;
	if (!comingSoonCount) return;

	const total = productsCount + comingSoonCount;
	const pluralize = (one, other) => (total === 1 ? one : other.replace("9999", total));
	const num = sectionEl.querySelector(".mm-num-products");
	if (submit && num) num.textContent = pluralize(results.dataset.mmCountOne, results.dataset.mmCountOther);
	const submitBtn = sectionEl.querySelector(".mm-drawer-collection-submit-btn");
	if (submitBtn) submitBtn.textContent = pluralize(results.dataset.mmResultsOne, results.dataset.mmResultsOther);
}

function mmComingSoonPlace(grid) {
	if (!grid || !grid.mmComingSoonPending || !grid.mmComingSoonPending.length) return;

	const placed = [];
	grid.mmComingSoonPending = grid.mmComingSoonPending.filter((card) => {
		const after = card.dataset.mmCsAfter;
		let ref = null;
		if (after) {
			ref = grid.querySelector(`.mm-product-card[data-mm-product-id="${after}"]`);
			if (!ref) return true;
		}
		// Plusieurs Coming soon à la suite : on garde leur ordre
		let next = ref ? ref.nextElementSibling : grid.firstElementChild;
		while (next && next.dataset.mmCsAfter === after) {
			next = next.nextElementSibling;
		}
		grid.insertBefore(card, next);
		placed.push(card);
		return false;
	});

	if (placed.length) mmComingSoonInitCards(placed);
}

// Mêmes initialisations que pour les cartes de la grille (slider, wishlist)
function mmComingSoonInitCards(cards) {
	cards.forEach((card) => card.setAttribute("data-mm-cs-init", ""));
	if (typeof productCardSlidersInit === "function") productCardSlidersInit(".mm-product-card[data-mm-cs-init]");

	cards.forEach((card) => {
		card.removeAttribute("data-mm-cs-init");

		card.querySelectorAll(".mm-pc-whishlist-modal-close").forEach((btnCloseWishlist) => {
			btnCloseWishlist.addEventListener("click", () => {
				closeWishlistModal(btnCloseWishlist);
			});
		});

		card.querySelectorAll(".mm-pc-wishlist-button").forEach((ctaWishlist) => {
			ctaWishlist.addEventListener("click", () => {
				closeWishlistModal(ctaWishlist);
				if (window.innerWidth < 768) {
					const productCard = document.querySelector(ctaWishlist.dataset.targetProductCard);
					productCard.classList.remove("mm-unbookmarked");
					productModalFilter.classList.remove("mm-open");
					document.querySelector("html").classList.remove("stop-scrolling");
				}
			});
		});
	});

	if (typeof ReloadSmartWishlist === "function") ReloadSmartWishlist();
}

// Arrivée sur une page déjà filtrée (rechargement, retour arrière)
window.addEventListener("DOMContentLoaded", async () => {
	const sectionEl = document.getElementById("shopify-section-" + window.__mmCollectionSectionId);
	if (!sectionEl) return;

	const num = sectionEl.querySelector(".mm-num-products");
	const productsCount = num ? parseInt(num.dataset.mmCount, 10) || 0 : 0;
	mmComingSoonApply(sectionEl, await mmComingSoonFetch(location.search.slice(1)), productsCount, true);
});
